import { React } from '@/app'
import {
  AuthModals,
  AuthWall,
  CenterWrapper,
  Link,
  Logo,
  Navigation,
  Onboarding,
  ProfileRedirectModal,
  UseAppBanner,
  View
} from '@/components'
import { concatStyles, useMediaQueryDown, useModal } from '@/utils'
import { ComponentVariants, StylesOf, useDefaultComponentStyle } from '@codeleap/common'
import { HeaderComposition, HeaderStyles } from '../../app/stylesheets/Header'
import { SuccessModal } from '../Modals/SuccessModal'
import { DrawerMenu } from './Drawer'
import { BASE_SITE_URL, BREAKPOINT, HeaderItems } from './Items'

type HeaderProps = ComponentVariants<typeof HeaderStyles> & {
  styles?: StylesOf<HeaderComposition>
  showBanner?: boolean
  onMenuToggle?: (visible: boolean) => void
}

const HeaderComponent = (props: HeaderProps) => {
  const { responsiveVariants, styles, variants, showBanner = true, onMenuToggle } = props
  const menu = useModal()

  React.useEffect(() => {
    onMenuToggle?.(menu.visible)
  }, [menu.visible])
  const isMobile = useMediaQueryDown(BREAKPOINT)

  const variantStyles = useDefaultComponentStyle<'u:Header', typeof HeaderStyles>('u:Header', {
    responsiveVariants,
    styles,
    variants
  })

  const headerStyles = React.useMemo(
    () => ({
      wrapper: concatStyles([variantStyles?.wrapper, menu?.visible && variantStyles?.['wrapper:open']]),
      wrapperFloating: concatStyles([
        variantStyles?.wrapperFloating,
        menu?.visible && variantStyles?.['wrapperFloating:open']
      ])
    }),
    [menu?.visible]
  )

  return (
    <>
      <Navigation.Container>
        <CenterWrapper
          styles={{
            innerWrapper: headerStyles.wrapper,
            wrapper: headerStyles.wrapperFloating
          }}
        >
          <Link to={BASE_SITE_URL} css={variantStyles.logoWrapper}>
            <Logo debugName="header logo" style={variantStyles.logo} breakpoint={BREAKPOINT} mobile={false} />
          </Link>

          {isMobile ? (
            <DrawerMenu variantStyles={variantStyles} {...menu} />
          ) : (
            <View variants={['alignCenter']}>
              <HeaderItems variantStyles={variantStyles} />
            </View>
          )}
        </CenterWrapper>
        {showBanner ? <UseAppBanner /> : null}
      </Navigation.Container>

      <AuthModals />
      <SuccessModal />
      <Onboarding />
      <ProfileRedirectModal />
      <AuthWall />
    </>
  )
}

export const Header = React.memo(HeaderComponent, () => true)
